import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query'

import {
    createServiceType,
    listActiveServiceTypes,
    listAllServiceTypes,
    updateServiceType,
} from './api'
import {settingsKeys} from './query-keys'
import type {CreateServiceTypeInput, UpdateServiceTypeInput} from './schemas'

export function useActiveServiceTypes({enabled = true}: {enabled?: boolean} = {}) {
    return useQuery({
        queryKey: settingsKeys.serviceTypes.active(),
        queryFn: listActiveServiceTypes,
        enabled,
    })
}

export function useAllServiceTypes() {
    return useQuery({
        queryKey: settingsKeys.serviceTypes.allList(),
        queryFn: listAllServiceTypes,
    })
}

export function useCreateServiceType() {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: (input: CreateServiceTypeInput) => createServiceType(input),
        onSuccess: () => {
            void queryClient.invalidateQueries({queryKey: settingsKeys.serviceTypes.all})
        },
    })
}

export function useUpdateServiceType() {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: ({id, input}: {id: string; input: UpdateServiceTypeInput}) =>
            updateServiceType(id, input),
        onSuccess: () => {
            void queryClient.invalidateQueries({queryKey: settingsKeys.serviceTypes.all})
        },
    })
}
